import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getAllDocumentWorkflowTemplatesList } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import { GetMasterDocumentsListParams } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/types.ts';
import { useMasterDocumentsEndpoints } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/api/useMasterDocumentsEndpoints.ts';

export const useMasterDocumentsQuery = (params: GetMasterDocumentsListParams) => {
	const { list: listKey } = useMasterDocumentsEndpoints();

	const { data, isLoading, isFetching, refetch } = useQuery({
		queryKey: [listKey, params],
		queryFn: getAllDocumentWorkflowTemplatesList,
		placeholderData: keepPreviousData,
	});

	return {
		documentWorkflowTemplates: data?.payload?.documentWorkflowTemplates ?? [],
		totalCount: data?.payload?.total ?? 0,
		isLoading,
		isFetching,
		refetch,
	};
};
